/**
 * Labstep
 *
 * @module core/Redirect
 * @desc Wrapper around react-router Redirect
 */

import { navigation } from 'labstep-web/services/navigation';
import type React from 'react';
import { Redirect as ReactRouterRedirect } from 'react-router-dom';
import type { IRedirectProps } from './types';

export const Redirect: React.FC<IRedirectProps> = ({
  to,
  params,
  state,
}) => (
  <ReactRouterRedirect
    to={{ pathname: navigation.get(to, params), state }}
  />
);
